import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { selectIsLoggedIn } from '../+state/auth.reducer';
import { map, Observable } from 'rxjs';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';

export const loginGuard = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
    const store = inject(Store);
    const router = inject(Router);

    return store.select(selectIsLoggedIn).pipe(
        map(isLoggedIn => {
            if (!isLoggedIn) {
                const returnUrl = next.queryParams['returnUrl'] || state.url.split('?')[0];
                return router.createUrlTree(['/login'], {
                    queryParams: {
                        ...next.queryParams,
                        returnUrl
                    }
                });
            }

            return true;
        })
    );
};
